<div class="footer-container" fxLayout fxLayoutAlign="flex-start" fxLayoutGap="5%">
    <div *ngIf="currentLanguage">
        <ng-template *ngIf="currentLanguage && languages" ngFor let-language [ngForOf]="languages">
            <button class="language" *ngIf="language.storeCode !== currentLanguage.storeCode"
                    (click)="switchLanguage(language)" mat-icon-button>
                <mat-icon class="language-logo" *ngIf="language.label === 'EN'"
                          svgIcon="hering-language-german"></mat-icon>
                <mat-icon class="language-logo" *ngIf="language.label === 'DE'"
                          svgIcon="hering-language-english"></mat-icon>
            </button>
        </ng-template>
    </div>
    <button *ngIf="isLoggedIn" mat-icon-button [matMenuTriggerFor]="accountMenu">
        <mat-icon svgIcon="hering-account"></mat-icon>
    </button>
</div>

<mat-menu #accountMenu="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">
    <button (click)="logout()" mat-menu-item i18n="@@header_account-menu-entry-logout">Logout</button>
</mat-menu>
